/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';

export const InputSimple = props => {
  const {
    initValue,
    getRef,
    type,
    onBlur,
    onChange,
    placeholder,
    className,
    style,
    resetValue,
    forcedValue,
  } = props;
  const [value, setValue] = useState(initValue ?? '');

  const ref = useRef(null);

  useEffect(() => {
    setValue(initValue ?? '');
  }, [initValue]);

  useEffect(() => {
    if (ref?.current && getRef) {
      getRef(ref);
    }
  }, [ref]);

  useEffect(() => {
    if (resetValue !== undefined && resetValue !== value) {
      setValue(resetValue ?? '');
    }
  }, [resetValue]);

  useEffect(() => {
    if (forcedValue !== undefined) {
      setValue(forcedValue ?? '');
    }
  }, [forcedValue]);

  const handleChange = e => {
    setValue(e.target.value);
    if (onChange) {
      onChange(e);
    }
  };

  return (
    <input
      ref={ref}
      className={`rounded bg-main bg-opacity-50 text-contrast text-opacity-80 flex-1 m-1 px-1 py-05 ${className}`}
      style={style}
      placeholder={placeholder}
      value={value ?? ''}
      type={type ?? 'text'}
      onChange={e => handleChange(e)}
      onBlur={e => onBlur?.(value)}
    />
  );
};
